import axios from 'axios'
import { ID } from '../../../../../_metronic/helpers'

const ADMIN_API_URL = process.env.REACT_APP_API_URL
const MY_URL = `${ADMIN_API_URL}/master/get-data`

const getZone = async () => {
    var result = await axios
      .get(`${MY_URL}/zone`)
      .then((response) => response.data)
      return result;
  }

const getState = async () => {
    var result = await axios
      .get(`${MY_URL}/state`)
      .then((response) => response.data)
      return result;
  }

  const getCity = async (id:ID) => {
    var result = await axios
      .get(`${MY_URL}/city/${id}`)
      .then((response) => response.data)
      return result;
  }

  const getDistrict = async (id:ID) => {
    var result = await axios
      .get(`${MY_URL}/district/${id}`)
      .then((response) => response.data)
      return result;
  }


const getDivision = async () => {
    var result = await axios
      .get(`${MY_URL}/division`)
      .then((response) => response.data)
      return result;
  }

  
const getSegment = async () => {
    var result = await axios
      .get(`${MY_URL}/segment`)
      .then((response) => response.data)
      return result;
  }
  const getOutletCategory = async () => {
    var result = await axios
      .get(`${MY_URL}/outlet-category`)
      .then((response) => response.data)
      return result;
  } 

  const getCustomertype = async (outlet_categoty_id:ID) => {
    var result = await axios
      .get(`${MY_URL}/customer-type/${outlet_categoty_id}`)
      .then((response) => response.data)
      return result;
  }

  const getSalesManUsers = async (zone_id:ID) => {
    var result = await axios
      .get(`${MY_URL}/sales-man-users/${zone_id}`)
      .then((response) => response.data)
      return result;
  }

  const  getReportingUsers = async () => {
    var result = await axios
      .get(`${MY_URL}/reporting-users`)
      .then((response) => response.data)
      return result;
  }

  const  getdesignation = async () => {
    var result = await axios
      .get(`${MY_URL}/designation`)
      .then((response) => response.data)
      return result;
  }
  const  getDepartment = async () => {
    var result = await axios
      .get(`${MY_URL}/department`)
      .then((response) => response.data)
      return result;
  }
  const  getRole = async () => {
    var result = await axios
      .get(`${MY_URL}/role`)
      .then((response) => response.data)
      return result;
  }

  const  getMenu = async () => {
    var result = await axios
      .get(`${MY_URL}/menu`)
      .then((response) => response.data)
      return result;
  }

  

  const  getWarehouse = async () => {
    var result = await axios
      .get(`${MY_URL}/warehouse`)
      .then((response) => response.data)
      return result;
  }

  const  getBeat = async () => {
    var result = await axios
      .get(`${MY_URL}/beat`)
      .then((response) => response.data)
      return result;
  }

  const  getBeatByAddress = async (state_id:ID, district_id:ID, city_id:ID) => {
    var result = await axios
      .get(`${MY_URL}/beatByAddress/${state_id}/${city_id}/${district_id}`)
      .then((response) => response.data)
      return result;
  }
 

  const getDealer = async (id:String) => {
    var result = await axios
      .get(`${MY_URL}/dealer/${id}`)
      .then((response) => response.data)
      return result;
  }

  const  getDealerByAddress = async (state_id:ID, district_id:ID, city_id:ID) => {
    var result = await axios
      .get(`${MY_URL}/dealerByAddress/${state_id}/${city_id}/${district_id}`)
      .then((response) => response.data)
      return result;
  }

  const  getOutlet = async () => {
    var result = await axios
      .get(`${MY_URL}/outlets`)
      .then((response) => response.data)
      return result;
  }

  const  getUsersByReportingId = async () => {
    var result = await axios
      .get(`${MY_URL}/getUsersByReportingId`)
      .then((response) => response.data)
      return result;
  }


  const  getAllMtpUsers = async () => {
    var result = await axios
      .get(`${MY_URL}/getAllMtpUsers`)
      .then((response) => response.data)
      return result;
  }

  

  const  getUsersExpenseAdded = async (exp_date:string) => {
    var result = await axios
      .get(`${MY_URL}/getUsersExpenseAdded/${exp_date}`)
      .then((response) => response.data)
      return result;
  }

  

  const  getMasterCount = async (table:String) => {
    var result = await axios
      .get(`${MY_URL}/getMasterCount/${table}`)
      .then((response) => response.data)
      return result;
  }

  const  getOrderCount = async (table:String) => {
    var result = await axios
      .get(`${MY_URL}/getOrderCount/${table}`)
      .then((response) => response.data)
      return result;
  }

  const  getAttendanceStatusCount = async (table:String) => {
    var result = await axios
      .get(`${MY_URL}/getAttendanceStatusCount/`)
      .then((response) => response.data)
      return result;
  }



export {getZone, getState , getDivision, getCity, getDistrict, getSegment, getOutletCategory,getCustomertype, getSalesManUsers, 
  getReportingUsers, getdesignation, getDepartment,getRole,getMenu, getWarehouse, getBeat, getDealer,getBeatByAddress, 
  getDealerByAddress, getOutlet,getUsersByReportingId,getMasterCount,getOrderCount,getUsersExpenseAdded,getAllMtpUsers,getAttendanceStatusCount }
